import $ from 'jquery'
import _ from "underscore"
import SimpleTooltip from '../../../SimpleTooltip'
import messageResource from '../../../messageResource'
import FilterDialog from './FilterDialog'
import DropdownDialog from '../../../controls/DropdownDialog'
import ViewTTStore from '../ViewTTStore'
import {Feature} from '../../../features'
import {CustomersProjectsSelectionQualifier, WeekApprovalStatus} from 'constants'

export default function FilterController() {};

FilterController.parseDateRangeConfig = function(dateRangeConfig)
{
    return DateRangeSelectorController.prototype.parseJSON.call(this, dateRangeConfig);
};

FilterController.prototype = {

    defaultCPSelectorId: "cpSelector",
    noTTACPSelectorId: "noTTACPSelector",

    _triggerDateRangeChange: function()
    {
        $(document).trigger("viewTT.dateRangeChange", this.getDateRange());
    },

    getDateRange: function()
    {
        return this.dateSelectorController.getSelectedRange();
    },

    _triggerFilterChange: function(filter)
    {
        this._updateEmptyCPSelectionStatus(filter.cpSelection);
        $(document).trigger("viewTT.filterChange", [filter]);
    },

    init: function()
    {
        var self = this;
        this._ignoreWeekApprovalStatuses = false;

        var $filterDialogEl = $('#filterDialog');
        this._filterDialog = new FilterDialog().init($filterDialogEl);

        this.$filterContainer = $('#viewTTFilterContainer');
        this.$filterEditButton = this.$filterContainer.find('.filterEditButton .commonVisibleFilterButton')
        this.$filterClearButton = this.$filterContainer.find('.filterClearButton');
        this.$filterSelectorButton = this.$filterContainer.find('.noTTACPSelector .commonVisibleFilterButton')

        this.filterEditDialog = new DropdownDialog({
            wrapperClass: 'viewTTFilterDialogWrapper noprint ui-dialog-titlebar ui-widget-header ui-corner-all ui-helper-clearfix',
            dialogDiv: $filterDialogEl,
            hideButtons: true,
            hideOnResize: true,
            showEmptyTitleBar: false,
            outsideClickCallback: function() {self._editFiltersCanceled();},
            hideOnResizeCallback: function() {self._editFiltersCanceled();},
            onClose: function(event)
            {
                if (event.keyCode === $.ui.keyCode.ESCAPE)
                    self._editFiltersCanceled();

                self.$filterEditButton.removeClass("pressed")
            }
        });

        this.$filterEditButton.click(function()
                                     {
                                         self.$filterEditButton.addClass("pressed")

                                         self._fillDialogData();

                                         self.filterEditDialog.showAt(this, {
                                             offset: "0 6px",
                                             my: "left top",
                                             at: "left bottom",
                                             collision: "none"
                                         });

                                         // don`t know better solution for removing focus from some input in dialog
                                         $filterDialogEl.parent().focus();
                                     });

        var $applyEditButton = $('#applyFilterEdit');
        var $cancelEditButton = $('#cancelFilterEdit');

        $applyEditButton.click(function()
                               {
                                   self._setNewFilter();
                                   self._hideDialog();
                               });
        $cancelEditButton.click(function() { self._hideDialog(); });

        this.$filterClearButton.click(function()
                                      {
                                          self._restoreFilter();
                                      });

        this.defaultFilter = this._createDefaultFilter();

        // init date range selector
        this.dateSelectorController = new DateRangeSelectorController().init({
                                                                                 dateRangeSelection: ViewTTStore.getDateRangeConfig(),
                                                                                 dateRangeParsed: true,
                                                                                 rangeMaxDays: 366,
                                                                                 rangeTooLongMessageKey: "date_range_selector.range_error.longer_than_1_year",
                                                                                 renderTo: 'viewTTDateSelector',
                                                                                 menuStates: this._createDateRangeMenu()
                                                                             });
        this.dateSelectorController.setOnChangeCallback(_.bind(this._triggerDateRangeChange, this));


        this.errorTooltip = new SimpleTooltip({
            text: messageResource.getMessage('view_tt.filter.tooltip.cp_selection_empty'),
            extraClass: 'viewTTPageFilterErrorTooltip',
        }).init($('body'))

        this.errorTooltip.subscribeToMouseEvents(this.$filterEditButton);
        this.errorTooltip.subscribeToMouseEvents(this.$filterSelectorButton);
        this.errorTooltip.disable();

        $(ViewTTStore).on("dataChange", _.bind(this._reInitCPSelector, this));
        $(ViewTTStore).on("dataConfigRestored", _.bind(this._reInit, this));
        this.ttaEnabled = null;
        this._reInitCPSelector();

        return this;
    },

    _reInit: function()
    {
        this.dateSelectorController.setSelectedRange(ViewTTStore.getDateRangeConfig());
        this._reInitCPSelector();
    },

    _reInitCPSelector: function()
    {
        var ttaEnabled = ViewTTPageUtils.isFeatureEnabled(Feature["TTA"]);
        this._ignoreWeekApprovalStatuses = ViewTTStore.getUserInfo()["autoApproved"];

        if (ttaEnabled !== this.ttaEnabled)
        {
            if (ttaEnabled)
            {
                if (!this.defaultCPSelector)
                    this.defaultCPSelector = this._makeCPSelector(this.defaultCPSelectorId);
                else
                    this.defaultCPSelector.markAsInvalid();

                this.cpSelector = this.defaultCPSelector;
            }
            else
            {
                if (!this.noTTACPSelector)
                    this.noTTACPSelector = this._makeNoTTACPSelector();
                else
                    this.noTTACPSelector.markAsInvalid();

                this.cpSelector = this.noTTACPSelector;
            }

            this.$filterContainer.toggleClass('ttaEnabled', ttaEnabled);

            this.ttaEnabled = ttaEnabled;
        }

        if (this.ttaEnabled)
            this._filterDialog.activateStatusesSection(!this._ignoreWeekApprovalStatuses);

        this._updateFilterStatus(ViewTTStore.getFilter());
    },

    _createDateRangeMenu: function()
    {
        return [
            new AT.CurrentMonthMenuItem(),
            new AT.PreviousMonthMenuItem(),
            AT.DateRangeSelectorSeparator,
            new AT.CurrentWeekNoImgMenuItem(),
            new AT.PreviousWeekNoImgMenuItem(),
            AT.DateRangeSelectorSeparator,
            new AT.CurrentQuarterMenuItem(),
            new AT.PreviousQuarterMenuItem(),
            AT.DateRangeSelectorSeparator,
            new AT.CustomDateRangeMenuItem()
        ];
    },

    // default is all enabled
    _createDefaultFilter: function()
    {
        return {
            cpSelection: {
                customers: [],
                projects: [],
                showArchivedProjects: false,
                qualifier: CustomersProjectsSelectionQualifier.ALL
            },
            weekApprovalStatuses: [WeekApprovalStatus.APPROVED, WeekApprovalStatus.READY,
                                   WeekApprovalStatus.NOT_READY, WeekApprovalStatus.REJECTED]
        };
    },

    _editFiltersCanceled: function()
    {
        this._hideDialog();
    },

    _hideDialog: function()
    {
        this.filterEditDialog.hide();
    },

    _removeCPSelectionError: function()
    {
    },

    _makeCPSelector: function(id, selectorConstructor)
    {
        var self = this;
        var configChanged = function()
        {
            self._removeCPSelectionError();

            if (!self.ttaEnabled)
            {
                var filter = ViewTTStore.getFilter();
                var cpSelection = self._getCPSelection();
                if (self._isCPSelectorChanged(cpSelection, filter.cpSelection))
                {
                    filter.cpSelection = cpSelection;
                    self._triggerFilterChange(filter);
                }
            }

            self.cpSelector.setInitialValueFromCurrent();
        };

        var cpSelector = _.isUndefined(selectorConstructor) ?
                         new ViewTTPage.ViewTTCPSelector() :
                         new selectorConstructor();
        cpSelector.init(ViewTTStore.getFilter().cpSelection, id, configChanged);

        cpSelector.panel.on("change", function()
        {
            cpSelector.setWasChanged();
        });
        $(cpSelector).on("selectionChange", function()
        {
            var cpSelection = cpSelector.isValid() ? cpSelector.getCpSelection() : ViewTTStore.getFilter()["cpSelection"];
            self._updateEmptyCPSelectionStatus(cpSelection);
        });
        this._updateEmptyCPSelectionStatus(cpSelector.getCpSelection());

        return cpSelector;
    },

    _makeNoTTACPSelector: function()
    {
        var $containerEl = this.$filterSelectorButton;
        var $btnLabel = $containerEl.find('.label');

        var btnConstructor = function(buttonConfig)
        {
            ViewTTPage.ViewTTCPSelectorDropDownButton.call(this, buttonConfig);
            this.buttonHandler = _.bind(this.showMenu, this);
        };
        btnConstructor.prototype = _.create(ViewTTPage.ViewTTCPSelectorDropDownButton.prototype, {
            init: function(cpSelector)
            {
                ViewTTPage.ViewTTCPSelectorDropDownButton.prototype.init.call(this, cpSelector);
                this._subscribeButton();
                return this;
            },

            setText: function(text)
            {
                $btnLabel.html(text);
            },
            _showMenu: function()
            {
                if (this.menu)
                {
                    this._unsubscribeButton();
                    $containerEl.toggleClass('pressed', true)
                    this.menu.show($containerEl[0], this.menuAlign);
                }
                return this;
            },
            onMenuHide: function(menu)
            {
                $containerEl.toggleClass('pressed', false)
                ViewTTPage.ViewTTCPSelectorDropDownButton.prototype.onMenuHide.call(this, menu);
                // 250 is the value that used in Ext.js when we open CPSelector in dialog
                _.delay(_.bind(this._subscribeButton, this),250);
            },

            _subscribeButton: function()
            {
                $containerEl.on('click', this.buttonHandler);
            },

            _unsubscribeButton: function()
            {
                $containerEl.off('click', this.buttonHandler);
            }
        });

        var selectorConstructor = function() {};
        selectorConstructor.prototype = _.create(ViewTTPage.ViewTTCPSelector.prototype, {
            _createDropDownButton: function(buttonConfig)
            {
                return new btnConstructor(buttonConfig);
            }
        });

        return this._makeCPSelector(this.noTTACPSelectorId, selectorConstructor);
    },

    _getCPSelection: function()
    {
        return this.cpSelector.getCpSelection();
    },

    _fillDialogData: function()
    {
        var filter = ViewTTStore.getFilter();

        if(!this._ignoreWeekApprovalStatuses)
        {
            this._filterDialog.setStatuses(filter.weekApprovalStatuses);
        }
        this.cpSelector.setSelection(filter.cpSelection);
        this.cpSelector.setInitialValueFromCurrent();
    },

    _setNewFilter: function()
    {
        var filter = this._getDialogData();
        if (this._compareAndStoreFilter(filter))
            this._updateFilterStatus(filter);
    },

    _restoreFilter: function()
    {
        this._setFilterActive(false);
        var filter = this._createDefaultFilter();
        if(this._ignoreWeekApprovalStatuses)
        {
            filter.weekApprovalStatuses = ViewTTStore.getFilter()["weekApprovalStatuses"]
        }
        this._changeFilter(filter);
    },

    _updateFilterStatus: function(newFilter)
    {
        this._setFilterActive(this._isFilterChanged(newFilter, this.defaultFilter));
    },

    _updateEmptyCPSelectionStatus: function(cpSelection)
    {
        this.cpSelectionEmpty = !this._isCPSelectorValid(cpSelection);
        this.$filterContainer.toggleClass('cpSelectionEmpty', this.cpSelectionEmpty);
        this.errorTooltip.setEnabled(this.cpSelectionEmpty);
    },

    /**
     * Change ui based on filterStatus
     * @param isActive{Boolean}
     * @private
     */
    _setFilterActive: function(isActive)
    {
        this.$filterClearButton.toggleClass('filtered', isActive);
        this.$filterEditButton.toggleClass('filtered', isActive);
        this.$filterSelectorButton.toggleClass('filtered', isActive)
    },

    _getDialogData: function()
    {
        var weekApprovalStatuses = this._ignoreWeekApprovalStatuses ?
                                   ViewTTStore.getFilter()["weekApprovalStatuses"] :
                                   this._filterDialog.getStatuses();

        var cpSelection = this.cpSelector.isValid() ?
                          this._getCPSelection() :
                          ViewTTStore.getFilter()["cpSelection"];

        return {
            cpSelection: cpSelection,
            weekApprovalStatuses: weekApprovalStatuses
        };
    },

    _changeFilter: function(filter)
    {
        this._triggerFilterChange(filter);
    },

    _compareAndStoreFilter: function(newFilter)
    {
        if (!this._isFilterChanged(newFilter, ViewTTStore.getFilter()))
            return false;
        this._changeFilter(newFilter);
        return true;
    },

    _isFilterChanged: function(newFilter, defaultFilter)
    {
        if (this._isCPSelectorChanged(newFilter.cpSelection, defaultFilter.cpSelection))
        {
            return true;
        }
        if (this._ignoreWeekApprovalStatuses || !this.ttaEnabled)
        {
            return false;
        }
        else
        {
            return !this._isArraysEquals(newFilter.weekApprovalStatuses, defaultFilter.weekApprovalStatuses);
        }
    },

    _isCPSelectorChanged: function(cpSelection, defaultCPSelection)
    {
        if(cpSelection.qualifier !== defaultCPSelection.qualifier)
            return true;

        // check only for SELECTED qualifier
        return cpSelection.qualifier === CustomersProjectsSelectionQualifier.SELECTED && !(
               cpSelection.showArchivedProjects == defaultCPSelection.showArchivedProjects &&
               this._isArraysEquals(cpSelection.projects, defaultCPSelection.projects) &&
               this._isArraysEquals(cpSelection.customers, defaultCPSelection.customers));
    },

    _isCPSelectorValid: function(cpSelection)
    {
        return (!(cpSelection.qualifier === CustomersProjectsSelectionQualifier.SELECTED &&
                  cpSelection.customers.length === 0 &&
                  cpSelection.projects.length === 0));
    },

    _isArraysEquals: function(list1, list2)
    {
        if (list1.length != list2.length)
            return false;

        // we have small lists, so it`s ok for n^2
        for (var i = 0; i < list1.length; i++)
        {
            if (!_.contains(list2, list1[i]))
                return false;
        }

        return true;
    }
};


// WEBPACK FOOTER //
// ./web/js/user/viewtt/filter/FilterController.js